export default "__VITE_ASSET__UGLqYmmZ__"